export const error = {
  validation: {
    isString: 'უნდა იყოს სტრიქონი',
    isUrl: 'უნდა იყოს URL',
    isOptional: 'არასავალდებულოა',
    isBoolean: 'უნდა იყოს ლოგიკური მნიშვნელობა',
    isEnum: 'უნდა იყოს დაშვებული enum მნიშვნელობა',
    validateNested: 'ჩადგმული ველის ვალიდაცია ვერ გავიდა',
    isNumber: 'უნდა იყოს რიცხვი',
    isDate: 'უნდა იყოს Date ობიექტი',
    isArray: 'უნდა იყოს მასივი',
    isObject: 'უნდა იყოს ობიექტი',
    arrayMaxSize: 'არ უნდა შეიცავდეს {{max}}-ზე მეტ ელემენტს',
    isNotEmpty: 'არ უნდა იყოს ცარიელი',
    maxLength: 'უნდა იყოს არაუმეტეს {{max}} სიმბოლო',
    isUUID: 'უნდა იყოს UUID',
    arrayMinSize: 'უნდა შეიცავდეს მინიმუმ {{min}} ელემენტს',
    min: 'არ უნდა იყოს {{min}}-ზე ნაკლები',
    equals: 'უნდა ემთხვეოდეს {{value}}-ს',
    notEquals: 'არ უნდა ემთხვეოდეს {{value}}-ს',
    isDecimal: 'უნდა იყოს ათწილადი რიცხვი',
    arrayUnique: 'ყველა ელემენტი უნდა იყოს უნიკალური',
    isEmail: 'ელ. ფოსტის მისამართი არასწორია',
    isNumberString: 'უნდა იყოს რიცხვის სტრიქონი',
    isFQDN: 'უნდა იყოს სრული დომენის სახელი',
    isInt: 'უნდა იყოს მთელი რიცხვი',
    minLengthIfNotEmpty:
      '$property უნდა შეიცავდეს მინიმუმ $constraint1 სიმბოლოს',
    sumArrayItemsPropertyEquals:
      '$property[...].$constraint1 ჯამი უნდა ემთხვეოდეს $constraint2-ს',
    customValidateName: 'სახელი არ აკმაყოფილებს მოთხოვნებს',
    customValidatePassword: 'პაროლი არ აკმაყოფილებს მოთხოვნებს',
    isEqualTo: '{{property}} უნდა ემთხვეოდეს {{relatedProperty}}-ს',
    isLuhnCardNumber: 'ბარათის ნომერი არასწორია',
  },
  custom: {
    invalidPromoCode: 'პრომო კოდი არასწორია',
    expiredPromoCode: 'პრომო კოდის ვადა ამოიწურა',
    activatedPromoCode: 'თქვენ უკვე გაააქტიურეთ ეს პრომო კოდი',
    passwordEqual: 'პაროლები უნდა ემთხვეოდეს',
    agreementRequired: 'საჭიროა წესებზე თანხმობა',
    emailUsed: 'ელ. ფოსტა უკვე გამოიყენება',
    emailVerificationUnavailable:
      'ამ ელ. ფოსტის შემოწმება ახლა ვერ ხერხდება. სცადეთ მოგვიანებით.',
    nameUsed: 'მომხმარებლის სახელი უკვე გამოიყენება',
    registrationEmailNotAllowed:
      'ამ ელ. ფოსტით რეგისტრაცია შეუძლებელია. სცადეთ სხვა.',
    emailNotFound: 'ელ. ფოსტა ვერ მოიძებნა',
    wrongPassword: 'არასწორი პაროლი',
    tooManyLogin: 'ძალიან ბევრი წარუმატებელი შესვლა. სცადეთ მოგვიანებით.',
    emailNotActivated: 'ელ. ფოსტა არ არის გააქტიურებული.',
    restoreLinkNotFound: 'აღდგენის ბმული ვერ მოიძებნა',
    passwordShouldDiffer: 'პაროლი უნდა განსხვავდებოდეს წინაგანისგან',
    incorrectActivationLink: 'არასწორი გააქტიურების ბმული.',
    tooManyFailedAttempts:
      'ძალიან ბევრი წარუმატებელი მცდელობა. სცადეთ გააქტიურება მოგვიანებით.',
    expiredActivationLink: 'გამოყენებულია ვადაგასული გააქტიურების ბმული',
    emailAlreadyActivated: 'ელ. ფოსტა უკვე გააქტიურებულია',
    authTokenMissing: 'ავტორიზაციის ტოკენი არ არის',
    tokenNotValid: 'ტოკენი არასწორია',
    subscriptionNotFound: 'გამოწერა ვერ მოიძებნა',
    subscriptionExceeded: 'გამოწერის ლიმიტი ამოწურულია',
    minimumDepositAmount: 'მინიმალური შევსების თანხაა $5',
    minimumWithdrawalAmount: 'მინიმალური გამოტანის თანხაა $50',
  },
};
